export default "__VITE_ASSET__wKJxvkhm__"